import { getCoreDataSecurityDetectedApplicationsActiveTokensSlice } from './get';

export const {
	requestGetCoreDataSecurityDetectedApplicationsActiveTokens,
	resetGetCoreDataSecurityDetectedApplicationsActiveTokens
} = getCoreDataSecurityDetectedApplicationsActiveTokensSlice.asyncActionCreators;
